import { EMPTY_GUIDANCE_STATE, type TGuidancePersistedState } from "./types";

const STORAGE_KEY_PREFIX = "fundy:guidance:";

const buildStorageKey = (userId: string) => `${STORAGE_KEY_PREFIX}${userId}`;

const isBrowser = () => typeof window !== "undefined" && typeof localStorage !== "undefined";

export const guidanceStorage = {
  read(userId: string | undefined | null): TGuidancePersistedState {
    if (!userId || !isBrowser()) {
      return { ...EMPTY_GUIDANCE_STATE };
    }

    try {
      const raw = localStorage.getItem(buildStorageKey(userId));
      if (!raw) {
        return { ...EMPTY_GUIDANCE_STATE };
      }

      const parsed = JSON.parse(raw) as Partial<TGuidancePersistedState>;
      return {
        tours: parsed.tours ?? {},
        tooltips: parsed.tooltips ?? {},
        banners: parsed.banners ?? {},
      };
    } catch {
      return { ...EMPTY_GUIDANCE_STATE };
    }
  },

  write(userId: string, state: TGuidancePersistedState): void {
    if (!isBrowser()) {
      return;
    }

    localStorage.setItem(buildStorageKey(userId), JSON.stringify(state));
  },

  clear(userId: string): void {
    if (!isBrowser()) {
      return;
    }

    localStorage.removeItem(buildStorageKey(userId));
  },
};
